import { render, staticRenderFns } from "./sheet-form.vue?vue&type=template&id=ffd3de10&scoped=true&"
import script from "./pc-sheet-form.ts?vue&type=script&lang=ts&"
export * from "./pc-sheet-form.ts?vue&type=script&lang=ts&"
import style0 from "./sheet-form.vue?vue&type=style&index=0&id=ffd3de10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd3de10",
  null
  
)

export default component.exports